import offerImage from './img/sweepstakes/fire-cube/320x180.jpg'
import SweepstakesBasePage from './SweepstakesBasePage'

const Page: React.FC = () => {
  return (
    <SweepstakesBasePage optionsId={''} funnelName="fire-cube" offerImage={offerImage} offerTitle="Amazon Fire Cube" />
  )
}

export default Page
